import React from 'react';
import { useSignature } from '../../contexts/SignatureContext';

interface FormArchetypeProps {
  title: string;
  subtitle?: string;
  statusBadge?: React.ReactNode;
  actionBar?: React.ReactNode;
  tabs?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * ARQUÉTIPO 2: FORM
 * Destinado a cadastros mestres, formulários com abas/seções e manutenção de dados.
 */
export const FormArchetype: React.FC<FormArchetypeProps> = ({
  title,
  subtitle,
  statusBadge,
  actionBar,
  tabs,
  children,
}) => {
  const { colors, densities } = useSignature();

  return (
    <div
      className="flex-1 flex flex-col h-full overflow-hidden"
      style={{
        backgroundColor: colors.bgApp,
        color: colors.textPrimary,
      }}
    >
      {/* Header do Formulário */}
      <div
        className="px-6 py-4 border-b shrink-0 flex items-center justify-between"
        style={{ borderColor: colors.border, backgroundColor: colors.bgSurface }}
      >
        <div>
          <div className="flex items-center gap-3">
            <h1 className="text-xl font-bold tracking-tight" style={{ color: colors.textPrimary }}>
              {title}
            </h1>
            {statusBadge}
          </div>
          {subtitle && (
            <p className="text-xs mt-0.5" style={{ color: colors.textSecondary }}>
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* Navegação por Abas (quando houver) */}
      {tabs && (
        <div
          className="px-6 border-b shrink-0 bg-slate-100/40 dark:bg-slate-900/40"
          style={{ borderColor: colors.border }}
        >
          {tabs}
        </div>
      )}

      {/* Conteúdo Principal Rolável */}
      <main
        className="flex-1 overflow-y-auto scrollbar-standard p-6 space-y-6"
        style={{ padding: `${densities.paddingMainPx}px` }}
      >
        <div className="max-w-7xl mx-auto space-y-6">{children}</div>
      </main>

      {/* Barra de Ações (ActionBar) Fixo - Regra 15: 85px de altura */}
      {actionBar && (
        <div
          className="shrink-0 border-t flex items-center justify-end px-6 shadow-lg"
          style={{
            height: `${densities.actionBarHeightPx}px`,
            borderColor: colors.border,
            backgroundColor: colors.bgSurface,
          }}
        >
          {actionBar}
        </div>
      )}
    </div>
  );
};
